import React from "react";
import { DS } from "../../theme-default";

/**
 * Shows the active search term a page received from the global search
 * (via its ?q= URL param) with a control to clear it. The global search
 * bar in the top bar is the only search input — pages never render one.
 */
export default function SearchFilterChip({ query, onClear }) {
  if (!query) {
    return null;
  }
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        verticalAlign: "middle",
        backgroundColor: DS.primaryTint,
        color: DS.primary,
        borderRadius: 999,
        padding: "4px 6px 4px 12px",
        fontSize: "0.82rem",
        fontWeight: 600,
        fontFamily: DS.font,
        maxWidth: 320,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={query}
      >
        Cautare: {query}
      </span>
      <button
        type="button"
        aria-label="Sterge cautarea"
        onClick={onClear}
        style={{
          border: "none",
          background: "transparent",
          color: DS.primary,
          cursor: "pointer",
          fontSize: "0.95rem",
          lineHeight: 1,
          padding: "2px 6px",
          borderRadius: 999,
        }}
      >
        ✕
      </button>
    </span>
  );
}
